<template>
  <div class="contentArea">
    <vs-row
      v-if="type == 'curriculum' || type == 'course' || type == 'banner'"
      class="card-area"
    >
      <vs-col vs-lg="1.5" vs-sm="2" vs-xs="1">
        <button @click="$router.go(-1)" class="back-btn">
          <img src="@/assets/images/elements/turnback.svg" />
          กลับ
        </button>
      </vs-col>
      <vs-col
        vs-lg="7"
        vs-sm="8"
        vs-xs="10"
        class="flex flex-col justify-center"
      >
        <Editcurriculum v-if="type == 'curriculum'" />
        <Editcourse v-if="type == 'course'" />
        <Editbanner v-if="type == 'banner'" />
      </vs-col>
      <vs-col vs-lg="1.5" vs-sm="2" vs-xs="1"></vs-col>
    </vs-row>
    <vs-row v-else class="card-area">
      <vs-col vs-lg="4" vs-sm="3" vs-xs="2">
        <button @click="$router.go(-1)" class="back-btn">
          <img src="@/assets/images/elements/turnback.svg" />
          กลับ
        </button>
      </vs-col>
      <vs-col
        vs-lg="4"
        vs-sm="6"
        vs-xs="8"
        class="flex flex-col justify-center"
      >
        <Editadministrator v-if="type == 'administrator'" />
        <EditcurriculumType v-if="type == 'curriculumType'" />
        <Editorganization v-if="type == 'organization'" />
        <Editvideo v-if="type == 'video'" />
        <Editlecturer v-if="type == 'lecturer'" />
      </vs-col>
      <vs-col vs-lg="4" vs-sm="3" vs-xs="2"></vs-col>
    </vs-row>
  </div>
</template>

<script>
import EditcurriculumType from "@/views/elements/course/editcurriculumType.vue";
import Editcurriculum from "@/views/elements/course/editcurriculum.vue";
import Editorganization from "@/views/elements/course/editorganization.vue";
import Editcourse from "@/views/elements/course/editcourse.vue";
import Editvideo from "@/views/elements/course/editvideo.vue";
import Editlecturer from "@/views/elements/course/editlecturer.vue";
import Editbanner from "@/views/elements/course/editbanner.vue";
import Editadministrator from "@/views/elements/course/editadministrator.vue";

export default {
  props: {
    type: String
  },
  components: {
    EditcurriculumType,
    Editcurriculum,
    Editorganization,
    Editcourse,
    Editvideo,
    Editlecturer,
    Editbanner,
    Editadministrator
  }
};
</script>

<style lang="scss" scoped>
.card-area {
  padding: 30px 20px;
  justify-content: center;
  border-radius: 5px;
  background: rgba(255, 255, 255, 0.6);
}
.back-btn {
  background: none !important;
  border: none;
}
</style>
